import locale from 'antd/lib/locale/cs_CZ';
import { mergeDeepRight } from 'ramda';
import { Locale } from 'antd/lib/locale-provider';
import { DeepPartial } from 'types/DeepPartial';

// NOTE: Ant design translations for CZ lang are incomplete so
// feel free to add translations for what you are missing or want to customize.
// Default translations can be found here: node_modules\antd\lib\locale\default.js
/* eslint-disable no-template-curly-in-string */
export const csCZ: Locale = mergeDeepRight(locale, {} as DeepPartial<Locale>) as Locale;
